import { useEffect, useState, useContext } from "react";
import { getInlineLoader } from "../Helpers";
import { FiLinkedin, FiTwitter, FiArrowUpRight, FiLayers, FiTerminal, FiGlobe } from "react-icons/fi";

import ceoImg from "../assets/user.png"; 
import managerImg from "../assets/manager.jpeg"; 
import faniImg from "../assets/fani.jpeg"; 
import johnImg from "../assets/john.jpg"; 
import dominicImg from "../assets/dominic.jpg"; 
import peter from "../assets/peter.jpeg"; 
import cooImg from "../assets/user.png";
import kelvinImg from "../assets/kelvin.jpg";
import glImg from "../assets/g_luck.jpg";
import { FaMailBulk, FaVoicemail } from "react-icons/fa";
import { IoMdMail } from "react-icons/io";
import { AppContext } from "../App";
import Footer from "./Footer";

export default function Staff() {
  const [ready, setReady] = useState(false);
  const appContext = useContext(AppContext);

  useEffect(() => {
    setReady(true);
  }, []);

  if (!ready) {
    return (
      <div className="container min-vh-100 d-flex align-items-center justify-content-center">
        {getInlineLoader()}
      </div>
    );
  }
    const leaders = [
        {
          name: "Peter Ndomano",
          role: "Managing Director",
          specialty: "Full-Stack Architect",
          image: peter,
          bio: "A strategic visionary leading technical direction, ensuring every digital solution is built for high performance, security, and global impact.",
        },
        {
          name: "Kelvin Rutaihwa",
          role: "Director of Customer Relations",
          specialty: "Operations & Strategy",
          image: kelvinImg,
          bio: "Dedicated to fostering strong client partnerships and aligning business objectives with seamless service delivery.",
        },
        {
          name: "Dominic Fezza",
          role: "Assistant CTO",
          specialty: "Operations",
          image: dominicImg,
          bio: "Focuses on optimizing internal infrastructures and technical workflows to maintain the highest standards of system reliability.",
        },
        {
          name: "John Gabriel",
          role: "Senior Developer",
          specialty: "Operations",
          image: johnImg,
          bio: "Specializes in building robust, scalable codebases and translating complex requirements into intuitive user experiences.",
        },
        {
          name: "Grace Alisen",
          role: "Manager",
          specialty: "Operations",
          image: managerImg,
          bio: "Oversees day-to-day operations and project management, ensuring cross-functional teams remain synchronized and efficient.",
        },
        {
          name: "Fani Michael",
          role: "Customer Relations Officer",
          specialty: "Operations",
          image: faniImg,
          bio: "The primary point of contact for client success, committed to providing timely support and maintaining exceptional satisfaction levels.",
        },
        {
          name: "Goodluck Msuya",
          role: "Tax Compliance & Audit",
          specialty: "Operations",
          image: glImg,
          bio: "Dedicated to ensuring seamless regulatory compliance and robust audit workflows, optimizing operational processes to minimize fiscal risk for clients.",
        },
      ];
  return (
    <>
      <section className="wer-staff-container bg-white p-3 py-5">
        <style>{`
          .wer-staff-container {
            font-family: 'Inter', system-ui, sans-serif;
            position: relative;
            overflow: hidden;
            padding: 100px 0;
          }

          /* Modern Background Blobs */
          .wer-blob {
            position: absolute;
            width: 500px;
            height: 500px;
            background: radial-gradient(circle, rgba(14, 165, 233, 0.05) 0%, rgba(255,255,255,0) 70%);
            z-index: 0;
            border-radius: 50%;
          }

          .wer-header-content {
            position: relative;
            z-index: 1;
          }

          /* Modern Image Overlays */
          .wer-img-frame {
            position: relative;
            width: 200px;
            height: 200px;
            z-index: 1;
          }

          .wer-img-frame::before {
            content: '';
            position: absolute;
            inset: -10px;
            background: linear-gradient(135deg, #e0f2fe 0%, #ffffff 100%);
            border-radius: 30px;
            z-index: -1;
            transition: transform 0.4s ease;
          }

          .wer-leader-card:hover .wer-img-frame::before {
            transform: rotate(3deg) scale(1.05);
            background: linear-gradient(135deg, #0ea4e98f 0%, #38bff88f 100%);
            opacity: 0.2;
          }

          .wer-img-main {
            width: 100%;
            height: 100%;
            border-radius: 24px;
            object-fit: cover;
            background: #f1f5f9;
            transition: all 0.5s ease;
            border: 4px solid #fff;
          }

          .wer-leader-card:hover .wer-img-main {
            transform: translateY(-5px);
            box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1);
          }

          /* Typography & Layout */
          .wer-badge-modern {
            font-size: 0.7rem;
            font-weight: 800;
            text-transform: uppercase;
            letter-spacing: 2px;
            color: #0ea5e9;
            padding-left: 40px;
            position: relative;
          }

          .wer-badge-modern::before {
            content: '';
            position: absolute;
            left: 0;
            top: 50%;
            width: 30px;
            height: 2px;
            background: #0ea5e9;
          }

          /* Glassmorphism Stats */
          .wer-glass-stats {
            background: rgba(255, 255, 255, 0.7);
            backdrop-filter: blur(10px);
            border: 1px solid rgba(241, 245, 249, 1);
            border-radius: 40px;
            padding: 60px;
            margin-top: 80px;
          }

          .wer-stat-item h3 {
            font-size: 2.5rem;
            font-weight: 800;
            margin-bottom: 0;
            color: #0f172a;
          }

          .wer-social-btn {
            width: 40px;
            height: 40px;
            border-radius: 12px;
            display: flex;
            align-items: center;
            justify-content: center;
            background: #f8fafc;
            color: #64748b;
            transition: all 0.3s ease;
            text-decoration: none;
          }

          .wer-social-btn:hover {
            background: #0f172a;
            color: #fff;
            transform: translateY(-3px);
          }
        `}</style>

        {/* Decorative background elements */}
        <div className="wer-blob" style={{ top: '-10%', right: '-10%' }}></div>
        <div className="wer-blob" style={{ bottom: '10%', left: '-5%' }}></div>

        <div className="container py-5">
          <div className="row align-items-end mb-5 wer-header-content">
            <div className="col-lg-7">
              <h1 className="display-4 font-bold text-primary mb-0">The Architects of <span className="text-secondary">Digital</span> Excellence.</h1>
            </div>
          </div>

          <div className="row g-5 mt-4">
            {leaders.map((leader) => (
              <div key={leader.name} className="col-lg-6">
                <div className="wer-leader-card d-md-flex align-items-center gap-4">
                  <div className="wer-img-frame mb-4 mb-md-0 flex-shrink-0">
                    <img src={leader.image} alt={leader.name} className="wer-img-main" />
                  </div>
                  <div className="wer-card-info">
                    <div className="d-flex align-items-center gap-2 mb-1">
                      <small className="text-primary fw-bold">{leader.role}</small>
                      <FiArrowUpRight className="text-light" />
                    </div>
                    <h3 className="fw-bold mb-2">{leader.name}</h3>
                    <p className="text-muted small mb-3 lh-base">{leader.bio}</p>
                    <div className="d-none gap-2">
                      <a href="#" className="wer-social-btn"><FiLinkedin size={16} /></a>
                      <a href="#" className="wer-social-btn"><IoMdMail size={16} /></a>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Stats / Value Section */}
          <div className="wer-glass-stats shadow-sm">
            <div className="row g-4 text-center">
              <div className="col-md-4 wer-stat-item">
                <FiTerminal className="mb-3 text-primary" size={24} />
                <h3>100%</h3>
                <p className="text-muted small fw-bold mt-2">Code Quality Audit</p>
              </div>
              <div className="col-md-4 wer-stat-item border-start border-end">
                <FiGlobe className="mb-3 text-primary" size={24} />
                <h3>24/7</h3>
                <p className="text-muted small fw-bold mt-2">Remote Operations</p>
              </div>
              <div className="col-md-4 wer-stat-item">
                <FiLayers className="mb-3 text-primary" size={24} />
                <h3>12+</h3>
                <p className="text-muted small fw-bold mt-2">Core Tech Stacks</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {
        appContext.navItem === 'team' ?
          <Footer />
          :
          ''
      }
    </>
  );
}